export const buildDataAttributes = (data, dataI, dataT) => {
  if (typeof dataI === 'undefined' && typeof data === 'undefined') {
    return {};
  }

  const attributes = Object.assign(data !== null && data !== void 0 ? data : {}, typeof dataI !== 'undefined' ? {
    i: dataI
  } : {}, typeof dataT !== 'undefined' ? {
    t: dataT
  } : {});
  return Object.keys(attributes).reduce((c, k) => Object.assign(Object.assign({}, c), {
    [`data-${k}`]: attributes[k]
  }), {});
};
//# sourceMappingURL=buildDataAttributes.js.map